export const HtmlTitleConfig = ({ title }: { title: string }) => (
  <title>{title}</title>
);
